// locationStore.ts
import { create } from 'zustand';

interface LocationState {
  latitude: number | null;
  longitude: number | null;
  setLatitude: (lat: number | null) => void;
  setLongitude: (lng: number | null) => void;
}

export const useLocationStore = create<LocationState>((set: (arg0: { latitude?: any; longitude?: any; }) => any) => ({
  latitude: null,
  longitude: null,
  setLatitude: (lat: any) => set({ latitude: lat }),
  setLongitude: (lng: any) => set({ longitude: lng }),
}));

